import { App } from "vue";
import qs from "qs";
import * as VueRouter from "vue-router";
import { authGuard } from "@auth0/auth0-vue";

import ClaimOverview from "@/pages/plugin/Overview.vue";
import ClaimTimeline from "@/pages/plugin/Timeline.vue";
import AcquisitionHistory from "@/pages/plugin/AcquisitionHistory.vue";
import ClaimAnalysis from "@/pages/plugin/Analysis.vue";
import ClaimPassengers from "@/pages/plugin/Passengers.vue";
import TravelAgencyOffices from "@/pages/TravelAgencyOffices.vue";
import Procedures from "@/pages/Procedures.vue";
import Users from "@/pages/Users.vue";
import Companies from "@/pages/Companies.vue";
import Signatures from "@/pages/Signatures.vue";
import Reporting from "@/pages/Reporting.vue";
import CreateClaim from "@/pages/CreateClaim.vue";

import DomainOnboarding from "@/pages/onboarding/1-Domain.vue";
import LegalAssetsOnboarding from "@/pages/onboarding/2-LegalAssets.vue";

import InboxEmails from "@/pages/inbox/Emails.vue"

import MainLayout from "@/layout/main.layout.vue";
import ClaimsLayout from "@/layout/claims.layout.vue";
import PluginLayout from "@/layout/plugin.layout.vue"
import OnboardingLayout from "@/layout/onboarding.layout.vue";
import { useTenantStore } from "@/store";

const router = VueRouter.createRouter({
  // @ts-ignore
  parseQuery: qs.parse,
  history: VueRouter.createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return {top: 0}
  },
  routes: [
    {
      path: '/onboarding/',
      name: 'Onboarding',
      component: OnboardingLayout,
      beforeEnter: [authGuard, async (to, from) => {
        if (to.fullPath !== from.fullPath) {
          console.log("to", to, "from", from);
          const currentStep = useTenantStore().tenant?.tenantOnboarding?.currentStep?.step || "DOMAIN";
          const routes = {
            "DOMAIN": "DomainOnboarding",
            "LEGAL_ASSETS": "LegalAssetsOnboarding"
          };
          
          if (routes[currentStep] && to.name !== routes[currentStep]) {
            return { name: routes[currentStep] };
          }
        }
      }],
      children: [
        {
          path: 'domain',
          name: "DomainOnboarding",
          component: DomainOnboarding
        },
        {
          path: 'branding',
          name: "LegalAssetsOnboarding",
          component: LegalAssetsOnboarding
        },
      ]
    },
    {
      path: '/',
      redirect: '/claims',
      name: 'Home',
      component: MainLayout,
      beforeEnter: authGuard,
      children: [
        {
          path: '/inbox',
          name: "Inbox",
          beforeEnter: authGuard,
          component: InboxEmails, 
        },
        {
          path: '/travel-agency',
          name: "TravelAgencyOffices",
          beforeEnter: authGuard,
          component: TravelAgencyOffices,
        },
        {
          path: '/procedures',
          name: "Procedures",
          beforeEnter: authGuard,
          component: Procedures,
        },
        {
          path: '/reporting',
          name: "Reporting",
          beforeEnter: authGuard,
          component: Reporting,
        },
        {
          path: '/users',
          name: "Users",
          beforeEnter: authGuard,
          component: Users,
        },
        {
          path: '/claims/create',
          name: "CreateClaim",
          beforeEnter: authGuard,
          component: CreateClaim,
        },
        {
          path: '/companies',
          name: "Companies",
          beforeEnter: authGuard,
          component: Companies,
        },
        {
          path: '/signature-requests',
          name: "Signatures",
          beforeEnter: authGuard,
          component: Signatures,
        },
        {
          path: '/claims',
          name: 'Claims',
          component: ClaimsLayout,
          beforeEnter: authGuard,
          children: [
            {
              path: '/claims/:id',
              component: PluginLayout,
              beforeEnter: [authGuard],
              children: [
                {
                  path: 'overview',
                  name: 'ClaimOverview',
                  component: ClaimOverview,
                  beforeEnter: authGuard,
                },
                {
                  path: 'timeline',
                  name: 'ClaimTimeline',
                  component: ClaimTimeline,
                  beforeEnter: authGuard,
                },
                {
                  path: 'acquisition-history',
                  name: 'AcquisitionHistory',
                  component: AcquisitionHistory,
                  beforeEnter: authGuard,
                },
                {
                  path: 'analysis',
                  name: 'ClaimAnalysis',
                  component: ClaimAnalysis,
                  beforeEnter: authGuard,
                },
                {
                  path: 'passengers',
                  name: 'ClaimPassengers',
                  component: ClaimPassengers,
                  beforeEnter: authGuard,
                },
              ]
            },
          ],
        },
      ]
    }
  ]
});

router.beforeEach((to: VueRouter.RouteLocationNormalized, from, next: VueRouter.NavigationGuardNext) => {
  next();
})

export default router;